import React from "react";
import ReactDOM from "react-dom";
import Routing from "./Routing/Routing";
import {Provider} from "react-redux";
import store from './Redux/store';
import axios from "axios";
import cmp from "semver-compare";
import packageJson from '../package.json';
import './index.scss';
import {logErrorAction} from "./Redux/actions/logActions";
import './Utils/dialog-directions.scss';
import MainErrorHandlerContainer from "./Redux/containers/MainErrorHandlerContainer";
import {hotjar} from 'react-hotjar';

const hjid = 2705001;
const hjsv = 6;

hotjar.initialize(hjid, hjsv);

let lastError;

window.onerror = function (message, file, line, column, errorObj) {
    if (lastError === errorObj)
        return false;

    logErrorAction(errorObj.name, errorObj.message, errorObj.stack).payload();

    lastError = errorObj;
}

function findGetParameter(parameterName) {
    let result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

const authKey = findGetParameter("authKey");

if (authKey)
    axios.defaults.headers.common['authKey'] = authKey;

const checkMinSupportedVersion = async () => {
    const {data: clientVersion} = await axios.get('/api/clientVersion');

    const minVersionComparison = cmp(clientVersion.min, packageJson.version);
    const maxVersionComparison = cmp(clientVersion.max, packageJson.version);

    if (minVersionComparison === 1 || maxVersionComparison === -1)
        window.location.reload();
};

setInterval(() => checkMinSupportedVersion(), 30000);

ReactDOM.render(
    (
        <Provider store={store}>
            <MainErrorHandlerContainer>
                <Routing/>
            </MainErrorHandlerContainer>
        </Provider>
    ),
    document.getElementById("root"));